import { render, staticRenderFns } from "./addKlpt.vue?vue&type=template&id=57091376"
import script from "./addKlpt.vue?vue&type=script&lang=js"
export * from "./addKlpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports